import Highcharts from "highcharts";

// HAMBURGER MENU MODULE IMPORTS
// These optional modules enable the hamburger menu (three dots icon) functionality
// across all chart components in the application
import Exporting from "highcharts/modules/exporting";
import Accessibility from "highcharts/modules/accessibility";

// Initialize the hamburger menu functionality globally
// This provides users with export and interaction options in the top-right corner of all charts
// Including: fullscreen view, download options (PNG, JPEG, PDF, SVG), print, and data export
Exporting(Highcharts);
Accessibility(Highcharts);

// Export configured Highcharts instance
export default Highcharts;
